<ng-container [ngSwitch]="context ? context.type : ''">
    <fui-edit-color-pair-input [control]="control" [disabled]="disabled" #input [(ngModel)]="value"
                               [label]="label" [labelI18NParams]="labelI18NParams" [placeholder]="placeholder"
                               (focussed$)="onFocussed($event)" *ngSwitchDefault [notation]="notation"
                               [backgroundEditable]="backgroundEditable"
                               [foregroundEditable]="foregroundEditable"
                               [allowBackgroundAlpha]="allowBackgroundAlpha"
                               [allowForegroundAlpha]="allowForegroundAlpha"
                               [showClearIcon]="showClearIcon" (onClear)="onClear.next()"
                               [(backgroundSelected)]="inputBackgroundSelected"
                               [okLabel]="okLabel" [resetLabel]="resetLabel">
    </fui-edit-color-pair-input>
    <fui-inline-color-pair-input [control]="control" [disabled]="disabled" #input [(ngModel)]="value"
                                 [placeholder]="placeholder"
                                 (focussed$)="onFocussed($event)" *ngSwitchCase="contextType.INLINE"
                                 [notation]="notation"
                                 [backgroundEditable]="backgroundEditable"
                                 [foregroundEditable]="foregroundEditable"
                                 [allowBackgroundAlpha]="allowBackgroundAlpha"
                                 [allowForegroundAlpha]="allowForegroundAlpha"
                                 [showClearIcon]="showClearIcon" (onClear)="onClear.next()"
                                 [(backgroundSelected)]="inputBackgroundSelected"
                                 [okLabel]="okLabel" [resetLabel]="resetLabel">
    </fui-inline-color-pair-input>
</ng-container>
